import { router } from "./Routes";
import { RouterProvider } from "react-router-dom";
import BreakpointsProvider from "./components/providers/BreakpointProvider"; // wrapped so we can create a context for breakpoints, and use it in the ProductGallery component
import { useAuthToken, useGetData } from "./hooks";
import Logo from "./Logo";
// import useAuthToken from "./hooks/useAuthToken";
// import useGetData from "./hooks/useGetData";
function App() {
  useAuthToken();
  const { isLoading } = useGetData();

  if (isLoading) {
    return (
      <div
        className="loading-screen"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: "12px",
          backgroundColor: "#fff",
        }}
      >
        <Logo />
        <div style={{ color: "#5e6e82", fontWeight: 600 }}>Cargando...</div>
      </div>
    );
  }

  return (
    <BreakpointsProvider>
      <RouterProvider router={router} />
    </BreakpointsProvider>
  );
  // wrap with other providers like appprivider if needed here
}

export default App;
// RouterProvider takes the router configuration and sets up the routing context for the entire app. enables features such as:
// 		Navigation between different routes.
// 		Access to route parameters.
// 	Handling of nested routes and layouts.
// 	 wrapping  application with RouterProvider,  the routes defined in the router object available throughout the app.
